// extracted by mini-css-extract-plugin
export default {"text":"MobileDescription_text__E0hLz","start-link":"MobileDescription_start-link__lrBpM"};